import { render, staticRenderFns } from "./LogCard.vue?vue&type=template&id=1fbe2c2a&scoped=true"
import script from "./LogCard.vue?vue&type=script&lang=js"
export * from "./LogCard.vue?vue&type=script&lang=js"
import style0 from "./LogCard.vue?vue&type=style&index=0&id=1fbe2c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe2c2a",
  null
  
)

export default component.exports